import Table from "components/DataTable/Table";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import MWoAddUpdateProduct from "./MWoAddUpdateProduct";

export default function MOProducts({ selectedWO }) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useSelector((state) => state.user.userInfo);

  /*   All States
   ********************************************* */
  const [MOProducts, setMOProducts] = useState(null);
  const [productTypes, setProductTypes] = useState(null);
  const [fabrics, setFabrics] = useState(null);

  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  /*   All Functions
   ********************************************* */
  const getMOProducts = async (m_woId) => {
    try {
      console.log("m_woId", m_woId);

      if (!m_woId) return;
      loadingOn();
      const { data } = await API.get(`/m-order/${m_woId}/products`, {
        headers: authHeader(),
      });
      if (data?.success) {
        setMOProducts(data.data);
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      console.error(err);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  // get All ProductTypes
  const getAllProductTypes = async () => {
    try {
      const { data } = await API.post(
        "/manufacturer/products/product-types",
        { page: 1, limit: 9999, filterBy: "all" },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setProductTypes(data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // get All ProductTypes
  const getAllMFabrics = async () => {
    try {
      const { data } = await API.post(
        "/manufacturer/products/fabrics",
        { page: 1, limit: 9999, filterBy: "all" },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setFabrics(data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = MOProducts.findIndex((item) => item.id === id);
    if (index === -1 || index === 0) return;

    const currentSortId = MOProducts[index]?.sortId;
    const currentId = MOProducts[index]?.id;
    const upSortId = MOProducts[index - 1].sortId;
    const upId = MOProducts[index - 1].id;
    try {
      const { data } = await API.post(
        "/m-wo-products/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getMOProducts(selectedWO?.m_woId);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = MOProducts.findIndex((item) => item.id === id);
    if (index === -1 || index === MOProducts.length - 1) return;
    const currentSortId = MOProducts[index]?.sortId;
    const currentId = MOProducts[index]?.id;
    const downSortId = MOProducts[index + 1].sortId;
    const downId = MOProducts[index + 1].id;
    try {
      const { data } = await API.post(
        "/m-wo-products/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getMOProducts(selectedWO?.m_woId);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const updateSearchParams = (key, value) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);

      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }

      return newParams.toString();
    });
  };

  const handleUpdateClick = (item) => {
    updateSearchParams("m_productId", item.m_productId);
    setIsUpdateMode(true);
    setShowAddUpdateModal(true);
  };

  const handleDelete = async (id) => {
    "m-wo-products/delete/:id";
    try {
      loadingOn();
      const { data } = await API.delete(`/m-wo-products/delete/${id}`, {
        headers: authHeader(),
      });
      if (data?.success) {
        dispatch(
          setNotification({
            message: "Product deleted successfully",
            type: "success",
          })
        );
        await getMOProducts(selectedWO?.m_woId);
      } else {
        dispatch(
          setNotification({
            message: data?.message || "Failed to delete product",
            type: "error",
          })
        );
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div className="d-flex">
      {(user?.permissions?.includes("m_wo_products") ||
        user?.roles === "admin") && (
        <>
          <button
            onClick={() => {
              setIsUpdateMode(false);
              setShowAddUpdateModal(true);
              updateSearchParams("m_productId", null);
            }}
            type="button"
            className="btn btn-primary  ms-1"
          >
            ADD Product
          </button>
        </>
      )}
    </div>
  );

  const buttons = () => (
    <div className=" d-flex justify-content-end ">
      {/* FilterBy */}
      <button
        type="button"
        className="px-1 bg-primary btn text-dark bg-opacity-10 border border-primary rounded-end mx-2 rounded-start"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {filterBy
          ? filterBy.toUpperCase().replaceAll("_", " ")
          : "Filter by All"}
      </button>
      <div className="dropdown-menu">
        <button onClick={() => setFilterBy(null)} className="dropdown-item">
          Filter by All
        </button>
        <button
          onClick={() => setFilterBy("productType")}
          className="dropdown-item"
        >
          Product type
        </button>
        <button
          onClick={() => setFilterBy("productStyle")}
          className="dropdown-item"
        >
          Product Style
        </button>
        <button
          onClick={() => setFilterBy("productColor")}
          className="dropdown-item"
        >
          Product Color
        </button>
        <button
          onClick={() => setFilterBy("productDescription")}
          className="dropdown-item"
        >
          Product Description
        </button>
        <button
          onClick={() => setFilterBy("totalQuantity")}
          className="dropdown-item"
        >
          Quantity
        </button>
      </div>
    </div>
  );

  const table_head = [
    "Item No",
    "Product Id",
    "Product Type",
    "Product Style",
    "Product Color",
    "Team Name",
    "Product Description",
    "Quantity",
    "Is Ready",
    "Actions",
  ];

  const table_body = (item, index) => (
    <tr
      key={item.id}
      onDoubleClick={() => {
        handleUpdateClick(item);
      }}
    >
      <td className="py-0 align-middle">{item.sortId}</td>
      <td className="py-0 align-middle">{item.m_productId} </td>
      <td className="py-0 align-middle">{item.productType} </td>
      <td className="py-0 align-middle">{item.productStyle}</td>
      <td className="py-0 align-middle">{item.productColor} </td>
      <td className="py-0 align-middle">{item.teamName} </td>
      <td className="py-0 align-middle">{item.productDescription} </td>
      <td className="py-0 align-middle">{item.totalQuantity} </td>
      <td className="py-0 align-middle">{item.isReady ? "Yes" : "No"} </td>
      <td className="d-flex py-0 align-items-center ">
        <Link
          to={`/manufacturer/m-orders/details/${selectedWO?.m_woId}?selected-tab=wo-audit&m_productId=${item.m_productId}`}
          className="btn btn-sm py-0 my-1 btn-info"
        >
          Audit
        </Link>
        {(user?.permissions?.includes("m_wo_products") ||
          user?.roles === "admin") && (
          <>
            <div
              onClick={() => {
                item.sortId !== 1 && sortUp(item.id);
              }}
              className="action-icon"
              style={{ cursor: "pointer" }}
            >
              <i className="mdi mdi-chevron-double-up"></i>
            </div>
            <div
              onClick={() => {
                item.sortId !== MOProducts?.length && sortDown(item.id);
              }}
              className="action-icon"
              style={{ cursor: "pointer" }}
            >
              <i className="mdi mdi-chevron-double-down"></i>
            </div>

            <div className="action-icon" style={{ cursor: "pointer" }}>
              <i
                onClick={() => {
                  handleUpdateClick(item);
                }}
                className="mdi mdi-pencil"
              ></i>
            </div>

            <DeleteModalButton
              btnClass={"action-icon btn p-0 "}
              deleteParams={item.id}
              deleteFunc={handleDelete}
            />
          </>
        )}
      </td>
    </tr>
  );

  useEffect(() => {
    if (!showAddUpdateModal) {
      setIsUpdateMode(false);
      updateSearchParams("m_productId", null);
      setShowAddUpdateModal(false);
    }
  }, [showAddUpdateModal]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (!selectedWO) return;
      getAllProductTypes();
      getAllMFabrics();
      getMOProducts(selectedWO?.m_woId);
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedWO]);

  return (
    <div>
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div
        className="d-flex flex-grow-1 "
        style={{ height: "100%", borderRadius: 15 }}
      >
        <div className="horizontal-scrollable  d-flex flex-grow-1 ">
          <Table
            filterBy={filterBy}
            buttons={buttons}
            defaultLimit={999}
            btn1={btn1}
            table_head={table_head}
            table_body={table_body}
            table_data={MOProducts || []}
          />
        </div>
      </div>
      <Modal
        show={showAddUpdateModal}
        onHide={() => {
          setShowAddUpdateModal(false);
        }}
        backdrop="static"
        size="xl"
        centered
        contentClassName="custom-border-radius bg-light"
      >
        {fabrics && productTypes && (
          <MWoAddUpdateProduct
            selectedMWo={selectedWO}
            MOProducts={MOProducts}
            isUpdateMode={isUpdateMode}
            showModal={setShowAddUpdateModal}
            productTypes={productTypes}
            fabrics={fabrics}
            refreshFunc={getMOProducts}
          />
        )}
      </Modal>
    </div>
  );
}
